"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateStreamingPlatformDto = instanceOfUpdateStreamingPlatformDto;
exports.UpdateStreamingPlatformDtoFromJSON = UpdateStreamingPlatformDtoFromJSON;
exports.UpdateStreamingPlatformDtoFromJSONTyped = UpdateStreamingPlatformDtoFromJSONTyped;
exports.UpdateStreamingPlatformDtoToJSON = UpdateStreamingPlatformDtoToJSON;
exports.UpdateStreamingPlatformDtoToJSONTyped = UpdateStreamingPlatformDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateStreamingPlatformDto interface.
 */
function instanceOfUpdateStreamingPlatformDto(value) {
    return true;
}
function UpdateStreamingPlatformDtoFromJSON(json) {
    return UpdateStreamingPlatformDtoFromJSONTyped(json, false);
}
function UpdateStreamingPlatformDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'display_order': json['display_order'] == null ? undefined : json['display_order'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
    };
}
function UpdateStreamingPlatformDtoToJSON(json) {
    return UpdateStreamingPlatformDtoToJSONTyped(json, false);
}
function UpdateStreamingPlatformDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'display_order': value['display_order'],
        'is_active': value['is_active'],
    };
}
